import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: "24px 24px 24px 24px",
    boxShadow: "none",
  },
  dropdowns: {
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoFlow: "column",
    alignItems: "end",
    gap: 20,
  },
}));